module.exports = __webpack_public_path__ + "static/media/other-man.960777ca.jpg";